import NpsPage from "@/projects/NPS/NpsUser/pages/Nps/NpsPage";
import NpsUserNavigationRoutes from "./navigationRoutes";
import NpsUserList from "../../../FinEaseHome/pages/AdminFinEase/Nps/NpsUserList";

const NpsUserRoutes = {
  dashboard: {
    path: NpsUserNavigationRoutes.NPS_OVERVIEW,
    component: NpsPage,
    name: "Nps Overview",
  },
  npsUserList: {
    path: NpsUserNavigationRoutes.NPS_USER_LIST,
    component: NpsUserList,
    name: "Nps User List",
  },
};

export default NpsUserRoutes;
